import React from 'react';
import styled from 'astroturf/react';

import { Body } from 'js/design_system/Body';
import { BodyLink } from 'js/design_system/link/BodyLink';
import { User } from 'js/liswp/Sidebar/hooks/types';

import UserAvatar from './UserAvatar';
import _Container from "UserCard-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/UserCard.tsx?styleId=Container";
import _Metadata from "UserCard-Metadata.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/UserCard.tsx?styleId=Metadata";
import _AuthorName from "UserCard-AuthorName.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/UserCard.tsx?styleId=AuthorName";
import _Institution from "UserCard-Institution.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/UserCard.tsx?styleId=Institution";
import _Footer from "UserCard-Footer.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/liswp/sidebar_ds/UserCard.tsx?styleId=Footer";


const Container = /*#__PURE__*/styled("div", null, {
  displayName: "Container",
  styles: _Container
});

const Metadata = /*#__PURE__*/styled("div", null, {
  displayName: "Metadata",
  styles: _Metadata
});

const AuthorName = /*#__PURE__*/styled("div", null, {
  displayName: "AuthorName",
  styles: _AuthorName
});

const Institution = /*#__PURE__*/styled("div", null, {
  displayName: "Institution",
  styles: _Institution
});

const Footer = /*#__PURE__*/styled("div", null, {
  displayName: "Footer",
  styles: _Footer
});

type Props = {
  user: User;
  small?: boolean; // Smaller avatar
  badge?: React.ReactNode;
  footer?: React.ReactNode;
};

const UserCard: React.FC<Props> = ({ user, small, badge, footer }) => (
  <Container>
    <UserAvatar user={user} small={small} />
    <Metadata>
      <AuthorName>
        {user.url ? (
          <BodyLink size="md" href={user.url}>
            {user.displayName}
          </BodyLink>
        ) : (
          <Body size="md">{user.displayName}</Body>
        )}
        {badge}
      </AuthorName>
      <Institution>
        {[user.university, user.position].filter(Boolean).join(', ')}
      </Institution>
      {footer && <Footer>{footer}</Footer>}
    </Metadata>
  </Container>
);

export default UserCard;
